import { useMutation, useQueryClient } from 'react-query';

import { deleteClient as remove } from 'api/clients/deleteClient';

const useDeleteClient = () => {
  const queryClient = useQueryClient();
  const {
    isSuccess,
    mutate: deleteClient,
    isLoading,
  } = useMutation(remove, {
    onSuccess: () => {
      queryClient.invalidateQueries('clients');
    },
  });

  return {
    isSuccess,
    deleteClient,
    isLoading,
  };
};

export default useDeleteClient;
